import { NavigateFunction } from "react-router";
import { BaseButton } from "../../../atoms/BaseButton";

interface Props {
  navigate: NavigateFunction;
}

export const ImageTextButton = ({ navigate }: Props) => {
  return (
    <div className="mt-10 flex flex-col px-10 md:flex-row md:px-20">
      <div className="mx-auto sm:w-1/2 xl:w-1/3">
        <img
          className="w-full"
          src={"/photos/home/to_left_side_picture/to_left_side_picture.jpg"}
          alt="logo"
          loading="lazy"
        />
      </div>
      <div className="mt-5 flex w-full flex-col text-xl md:mt-0 md:w-1/2 md:pl-10 md:text-2xl xl:w-2/3">
        <span>Currently a Model & Sport activist at Kaunas.</span>
        <span className="pt-6">
          Since my childhood I`ve always been passionate about clothes and
          fashion.
        </span>
        <span className="pt-6">
          I have always believed that what I wear can have an impact on my mood
          and I am hoping to transition my portfolio to modest modeling which
          will lead me into becoming a full-time model.
        </span>
        <span className="pt-6">
          My mission is to represent the community through fashion and modeling.
        </span>
        <BaseButton
          className="mt-10 text-lg"
          onClick={() => navigate("/portfolio")}
        >
          View projects
        </BaseButton>
      </div>
    </div>
  );
};
